<template>
  <section class="bg-light">
    <div class="container">
      <div class="pt-5">
        <ul class="nav nav-tabs nav-pills nav-fill flex-column flex-sm-row">
          <li class="nav-item">
            <a id="tab1" class="nav-link font-weight-bold active" @click="changeTab(1)">MI PRIMER
              SEMINUEVO</a>
          </li>
          <li class="nav-item">
            <a id="tab2" class="nav-link font-weight-bold" @click="changeTab(2)">EMPRESAS</a>
          </li>
          <li class="nav-item">
            <a id="tab3" class="nav-link font-weight-bold" @click="changeTab(3)">CHOQUES</a>
          </li>
          <li class="nav-item">
            <a id="tab4" class="nav-link font-weight-bold" @click="changeTab(4)">SITUACIÓN LEGAL -
              ADEUDOS</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-content bg-white" id="myTabContent">
      <div class="container">
        <div class="pt-4 pb-4">
          <transition name="custom-classes-transition" enter-active-class="animate__animated animate__fadeIn">
            <div v-if="tab === 1">
              <div class="row justify-content-center align-items-center">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div class="text-center">
                    <h3 class="title-home text-success-strong">
                      ¡TOMA UNA DECISIÓN INTELIGENTE!
                    </h3>
                    <p class="pr-0 pl-0 pr-md-5 pl-md-5 pr-lg-5 pl-lg-5 pr-xl-5 pl-xl-5 pt-1">
                      Para comprar un seminuevo hay varios puntos
                      muy importantes que tienes que tener en
                      cuenta, no sólo los kilometrajes.
                    </p>
                    <button class="btn btn-primary pulsingButton" v-scroll-to="'#home'">
                      <span class="title-home">Adquirir mi reporte</span>
                    </button>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <transition appear appear-class="animate__animated animate__fadeInRight"
                    appear-to-class="animate__animated animate__fadeInRight" (2.1.8+)
                    appear-active-class="animate__animated  animate__fadeInRight">
                    <img src="@/assets/images/landing_home/tab_1.jpg" alt="" class="img-fluid">
                  </transition>
                </div>
              </div>
            </div>
          </transition>
          <transition name="custom-classes-transition" enter-active-class="animate__animated animate__fadeIn">
            <div v-if="tab === 2">
              <div class="row justify-content-center align-items-center">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div class="text-center">
                    <h3 class="title-home text-success-strong">
                      TOTALCHECK ES TU ASESOR
                    </h3>
                    <p class="pr-0 pl-0 pr-md-5 pl-md-5 pr-lg-5 pl-lg-5 pr-xl-5 pl-xl-5 pt-1">
                      Somos tu respaldo para brindarte un reporte completo del
                      vehículo, desde los datos de regulación hasta el historial de
                      siniestros.
                    </p>
                    <button class="btn btn-primary pulsingButton" v-scroll-to="'#home'">
                      <span class="title-home">Adquirir mi reporte</span>
                    </button>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <transition appear appear-class="animate__animated animate__fadeInRight"
                    appear-to-class="animate__animated animate__fadeInRight" (2.1.8+)
                    appear-active-class="animate__animated  animate__fadeInRight">
                    <img src="@/assets/images/landing_home/tab_2.jpg" alt="" class="img-fluid">
                  </transition>
                </div>
              </div>
            </div>
          </transition>
          <transition name="custom-classes-transition" enter-active-class="animate__animated animate__fadeIn">
            <div v-if="tab === 3">
              <div class="row justify-content-center align-items-center">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div class="text-center">
                    <h3 class="title-home text-success-strong">
                      AHORRO EN REPARACIONES
                    </h3>
                    <p class="pr-0 pl-0 pr-md-5 pl-md-5 pr-lg-5 pl-lg-5 pr-xl-5 pl-xl-5 pt-1">
                      Pérdida total, número de piezas reparadas, reemplazadas,
                      pintadas, fecha y costo de reparación
                    </p>
                    <button class="btn btn-primary pulsingButton" v-scroll-to="'#home'">
                      <span class="title-home">Adquirir mi reporte</span>
                    </button>
                  </div>

                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <transition appear appear-class="animate__animated animate__fadeInRight"
                    appear-to-class="animate__animated animate__fadeInRight" (2.1.8+)
                    appear-active-class="animate__animated  animate__fadeInRight">
                    <img src="@/assets/images/landing_home/tab_3.jpg" alt="" class="img-fluid">
                  </transition>
                </div>
              </div>
            </div>
          </transition>
          <transition name="custom-classes-transition" enter-active-class="animate__animated animate__fadeIn">
            <div v-if="tab === 4">
              <div class="row justify-content-center align-items-center">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div class="text-center">
                    <h3 class="title-home text-success-strong">
                      INFORMACIÓN CONFIABLE
                    </h3>
                    <p class="pr-0 pl-0 pr-md-5 pl-md-5 pr-lg-5 pl-lg-5 pr-xl-5 pl-xl-5 pt-1">
                      Verifica si tiene reporte de robo ó si el número de serie está
                      remarcado. Además revisa si tiene adeudos de tenencias,
                      refrendos y multas.
                    </p>
                    <button class="btn btn-primary pulsingButton" v-scroll-to="'#home'">
                      <span class="title-home">Adquirir mi reporte</span>
                    </button>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <transition appear appear-class="animate__animated animate__fadeInRight"
                    appear-to-class="animate__animated animate__fadeInRight" (2.1.8+)
                    appear-active-class="animate__animated  animate__fadeInRight">
                    <img src="@/assets/images/landing_home/tab_4.jpg" alt="" class="img-fluid">
                  </transition>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ReportExplain',
  data() {
    return ({
      tab: 1
    });
  },
  methods: {
    changeTab(numTab) {
      var tab = document.getElementById("tab" + numTab);
      tab.classList.add("active");
      this.tab = numTab;
      var Tab1 = document.getElementById("tab1");
      var Tab2 = document.getElementById("tab2");
      var Tab3 = document.getElementById("tab3");
      var Tab4 = document.getElementById("tab4");
      switch (numTab) {
        case 1:
          Tab2.classList.remove("active");
          Tab3.classList.remove("active");
          Tab4.classList.remove("active");
          break;
        case 2:
          Tab1.classList.remove("active");
          Tab3.classList.remove("active");
          Tab4.classList.remove("active");
          break;
        case 3:
          Tab1.classList.remove("active");
          Tab2.classList.remove("active");
          Tab4.classList.remove("active");
          break;
        case 4:
          Tab1.classList.remove("active");
          Tab2.classList.remove("active");
          Tab3.classList.remove("active");
          break;

        default:
          break;
      }
    },
    // changeAutomatic(restart) {
    //   if (restart) {
    //     setInterval(() => {
    //       console.log(this.tab);
    //       this.tab = this.tab + 1;
    //       if (this.tab == 5) {
    //         this.tab = 1;
    //       }
    //       this.changeTab(this.tab);
    //       console.log(this.tab);
    //     }, 10000);
    //   }
    // },
  },
  mounted() {
    // this.changeAutomatic(true)
  }
}
</script>
<style scoped>
@media (max-width:469px) {
  .pulsingButton span {
    font-size: 14px !important;
  }
}

.nav-link {
  font-family: none;
  letter-spacing: 0px;
  font-size: auto;
  cursor: pointer;
}

.nav-fill .nav-item a {
  color: #a3a3a3;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: #00582a !important;
  background-color: #fff;
}
</style>